import { productsApi } from "./products";
import { pricesApi } from "./prices";
const paymentIntentsPath = `/v1/:tenantId/:environment/paymentIntents`;
const refundsPath = `/v1/:tenantId/:environment/refunds`;
const publicKeysPath = `/v1/:tenantId/:environment/publicKeys`;
export function amountWithTwoDecimalPlaces(amount) {
    return { _type: "amount.with.two.decimal.places", amount };
}
export function amountWithoutDecimalPlaces(amount) {
    return { _type: "amount.without.decimal.places", amount };
}
export function amountAndCurrency(amount, currency, metadata = {}) {
    return { _type: "amount.and.currency", amount, currency, metadata };
}
export function keyValue(key, value) {
    return { key, value };
}
export function metadata(...keyValues) {
    return keyValues.reduce((acc, kv) => {
        acc[kv.key] = kv.value;
        return acc;
    }, {});
}
export const paygCheckoutUri = `/v1/:tenantId/:environment/payg/checkout`;
export const customerCreateUri = `/v1/:tenantId/:environment/customer/create`;
export const customerRecordStripeResource = `/v1/:tenantId/:environment/record/:recordId/resource/customer`;
export const checkoutSessionCreateSubscriptionUri = `/v1/:tenantId/:environment/checkoutSession/createSubscription`;
export const getCheckoutSessionByIdUri = `/v1/:tenantId/:environment/checkoutSession/:sessionId`;
export const stripeCloudFunctionsApi = {
    v1: {
        fullyQualifiedUrl: (uri) => {
            const joiner = uri.startsWith("/") ? "" : "/";
            return `https://us-central1-docs-n-data.cloudfunctions.net/stripeCloudFunctions${joiner}${uri}`;
        },
        checkoutSession: {
            getById: {
                get: {
                    uri: {
                        path: getCheckoutSessionByIdUri,
                        constructor: (tenantId, environment, sessionId) => getCheckoutSessionByIdUri.replace(":tenantId", tenantId).replace(":environment", environment).replace(":sessionId", sessionId)
                    }
                }
            },
            createSubscription: {
                post: {
                    body: {
                        create(lookupKey, customerId, successUrl, cancelUrl, subscriptionMetadata) {
                            return {
                                _type: "checkout.session.create.subscription.payload",
                                lookupKey,
                                customerId,
                                successUrl,
                                cancelUrl,
                                subscriptionMetadata
                            };
                        }
                    },
                    uri: {
                        path: checkoutSessionCreateSubscriptionUri,
                        constructor: (tenantId, environment) => checkoutSessionCreateSubscriptionUri.replace(":tenantId", tenantId).replace(":environment", environment)
                    }
                }
            }
        },
        customer: {
            create: {
                post: {
                    body: {
                        create(email, name, metadata) {
                            return { _type: "customer.create.payload", email, name, metadata };
                        }
                    },
                    uri: {
                        path: customerCreateUri,
                        constructor: (tenantId, environment) => customerCreateUri.replace(":tenantId", tenantId).replace(":environment", environment)
                    }
                }
            }
        },
        payg: {
            checkout: {
                post: {
                    body: {
                        forCustomerRecord: (amount, currency, customerRecordId, metadata = {}) => {
                            return {
                                _type: "payg.checkout.for.customer.record",
                                customer: { recordId: customerRecordId },
                                amount: { _type: "amount.and.currency", amount, currency, metadata }
                            };
                        },
                        create: (amount, currency, customerEmail, metadata = {}) => {
                            return {
                                _type: "payg.checkout",
                                customer: {
                                    email: customerEmail
                                },
                                amount: { _type: "amount.and.currency", amount, currency, metadata }
                            };
                        }
                    },
                    uri: {
                        path: paygCheckoutUri,
                        constructor: (tenantId, environment) => paygCheckoutUri.replace(":tenantId", tenantId).replace(":environment", environment)
                    }
                }
            }
        },
        publicKeys: {
            get: {
                uri: {
                    path: publicKeysPath,
                    constructor: (tenantId, environment) => publicKeysPath.replace(":tenantId", tenantId).replace(":environment", environment)
                }
            }
        },
        paymentIntents: {
            post: {
                body: {
                    amountAndCurrency: (amount, currency, metadata = {}) => {
                        return { _type: "amount.and.currency", amount, currency, metadata };
                    },
                },
                uri: {
                    path: paymentIntentsPath,
                    constructor: (tenantId, environment) => paymentIntentsPath.replace(":tenantId", tenantId).replace(":environment", environment)
                }
            }
        },
        refunds: {
            post: {
                body: {
                    forPaymentIntent: (amount, paymentIntentId, metadata = {}) => {
                        return { _type: "refund.for.payment.intent", amount, paymentIntentId, metadata };
                    },
                },
                uri: {
                    path: refundsPath,
                    constructor: (tenantId, environment) => refundsPath.replace(":tenantId", tenantId).replace(":environment", environment)
                }
            }
        }
    }
};
export const stripeAdminFunctionsApi = {
    v1: {
        fullyQualifiedUrl: (uri) => {
            const joiner = uri.startsWith("/") ? "" : "/";
            return `https://us-central1-docs-n-data.cloudfunctions.net/stripeAdminFunctions${joiner}${uri}`;
        },
        ...productsApi,
        ...pricesApi
    }
};
